const cropContentInitialCrop = {
    croppedAreaPixels: null,
    isFromCloudinary: false,
    replacedImageUrl: null,
};

export const defaultCropData = [
    {
        ...cropContentInitialCrop,
        ratio: 16 / 9,
        ratioName: '16 : 9',
        aspect: {
            width: 16,
            height: 9,
        },
        visibilityCondition: ({ isVerticalMedia }) => !isVerticalMedia,
    },
    {
        ...cropContentInitialCrop,
        ratio: 6 / 5,
        ratioName: '6 : 5',
        aspect: {
            width: 6,
            height: 5,
        },
        visibilityCondition: ({ isVerticalMedia }) => !isVerticalMedia,
    },
    {
        ...cropContentInitialCrop,
        ratio: 2,
        ratioName: '2 : 1',
        aspect: {
            width: 2,
            height: 1,
        },
        visibilityCondition: ({ isVerticalMedia }) => !isVerticalMedia,
    },
    {
        ...cropContentInitialCrop,
        ratio: 1.91,
        ratioName: '1.91 : 1',
        aspect: {
            width: 191,
            height: 100,
        },
        visibilityCondition: ({ isVerticalMedia }) => !isVerticalMedia,
    },
    {
        ...cropContentInitialCrop,
        ratio: 1,
        ratioName: '1 : 1',
        aspect: {
            width: 1,
            height: 1,
        },
        visibilityCondition: ({ isVerticalMedia }) => !isVerticalMedia,
    },
    {
        ...cropContentInitialCrop,
        ratio: 4 / 5,
        ratioName: '4 : 5',
        aspect: {
            width: 4,
            height: 5,
        },
        visibilityCondition: ({ isVerticalMedia }) => isVerticalMedia,
    },
    {
        ...cropContentInitialCrop,
        ratio: 9 / 16,
        ratioName: '9 : 16',
        aspect: {
            width: 9,
            height: 16,
        },
        visibilityCondition: ({ isVerticalMedia }) => isVerticalMedia,
    },
    {
        ...cropContentInitialCrop,
        ratio: 1 / 2,
        ratioName: '1 : 2',
        aspect: {
            width: 1,
            height: 2,
        },
        visibilityCondition: ({ isVerticalMedia }) => isVerticalMedia,
    },
];
